import React from 'react';
import { Text } from 'rebass';
import colors from 'theme/colors';

const LabelAsterisk: React.FC<any> = (props): JSX.Element => (
  <Text as="span" fontSize="18px" fontWeight={6} color={colors.red} {...props}>
    &nbsp;*
  </Text>
);

export default LabelAsterisk;
